module.exports = __webpack_public_path__ + "img/logo.670bc06b.png";